export default "https://cdn-static.gokick.com/assets/528ec2ebd6131ff545f204827e0544e2c800444b/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";